<template>
  <div>
    <q-splitter
      class="full-height"
      v-model="splitterModel"
      style="height: 250px"
    >
      <template v-slot:before>
        <q-tabs v-model="tab" vertical class="text-teal">
          <q-tab
            name="辦法"
            class="text-deep-orange-5 full-width material-icons"
            label="辦法"
            >article</q-tab
          >
          <q-tab
            name="表單"
            class="text-deep-orange-5 full-width material-icons"
            label="表單"
            >view_list</q-tab
          >
        </q-tabs>
      </template>

      <template v-slot:after>
        <q-tab-panels
          v-model="tab"
          animated
          vertical
          transition-prev="jump-up"
          transition-next="jump-up"
        >
          <q-tab-panel name="辦法">
            <div class="text-h4 q-mb-md">辦法</div>
            <div class="q-pa-md">
              <q-btn
                color="blue-grey-6"
                class="full-width"
                label="教師評審委員會設置辦法"
                type="a"
                href="https://fdm.kh.usc.edu.tw/var/file/35/1035/img/826/638682567.docx"
                target="_blank"
              />
              <q-btn
                color="grey-6"
                class="full-width"
                label="學生競賽獎勵辦法實施要點"
                type="a"
                href="https://fdm.kh.usc.edu.tw/var/file/35/1035/img/826/484635527.docx"
                target="_blank"
              />
              <q-btn
                color="blue-grey-6"
                class="full-width"
                label="證照獎勵辦法"
                type="a"
                href="https://fdm.kh.usc.edu.tw/var/file/35/1035/img/826/588499578.docx"
                target="_blank"
              />
            </div>
          </q-tab-panel>

          <q-tab-panel name="表單">
            <div class="text-h4 q-mb-md">表單</div>
            <div class="q-pa-md"></div>
          </q-tab-panel>
        </q-tab-panels>
      </template>
    </q-splitter>
  </div>
</template>

<script>
import { ref } from "vue";

export default {
  setup() {
    return {
      tab: ref("辦法"),
      splitterModel: ref(20)
    };
  },
  components: {}
};
</script>
